import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const BACKEND = BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Retry automatico su errori transitori (502/503/504 o rete assente),
// tipici durante un riavvio del backend, così l'accesso non fallisce.
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
api.interceptors.response.use(undefined, async (error) => {
  const config = error.config;
  if (!config) return Promise.reject(error);
  const status = error.response?.status;
  const transient = status === 502 || status === 503 || status === 504 || !error.response;
  const method = (config.method || "get").toLowerCase();
  const isAuth = (config.url || "").includes("/auth/");
  const safeToRetry = method === "get" || isAuth; // evita doppie POST non idempotenti
  config.__retryCount = config.__retryCount || 0;
  if (transient && safeToRetry && config.__retryCount < 3) {
    config.__retryCount += 1;
    await sleep(1200 * config.__retryCount);
    return api(config);
  }
  return Promise.reject(error);
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export default api;

// Normalizza qualsiasi URL immagine/media al backend CORRENTE.
// Gestisce: path relativi (/api/...), URL assoluti con dominio preview
// obsoleto (li riscrive al backend attuale) e URL esterni (invariati).
export function mediaUrl(u) {
  if (!u) return "";
  if (u.startsWith("/")) return `${BACKEND}${u}`;
  const m = u.match(/(\/api\/(?:image|media)\/[^\s"']+)$/);
  if (m) return `${BACKEND}${m[1]}`;
  return u;
}
